import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';
import { MappingComponent } from '../../mapping/mapping.component';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
    selector: 'app-edit-field',
    templateUrl: './edit-field.component.html',
    styleUrls: ['./edit-field.component.css'],
    standalone: false
})
export class EditFieldComponent implements OnInit {

  fieldForm = new FormGroup({
    name: new FormControl('', Validators.compose([
      Validators.required,
      Validators.maxLength(30),
      // Validators.pattern('^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$'),
      // Validators.pattern(".*\\S.*[a-zA-z0-9 ]"),
      Validators.pattern(/^((?!\s{2,}).)*$/)
    ]))
  });

  public field_validation_messages;

  fieldName = this.data.fieldNameDisplayed;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<MappingComponent>) {

    this.field_validation_messages = {
      'name': [
        { type: 'required', message: translate.instant('ADD-FIELD-DIALOG.ERROR-NAME-REQUIRED') },
        { type: 'maxlength', message: translate.instant('ADD-FIELD-DIALOG.ERROR-NAME-LENGTH') },
        { type: 'pattern', message: translate.instant('ADD-FIELD-DIALOG.ERROR-PATTERN') }
      ]
    }

    this.dialogRef.backdropClick().subscribe(() => {
      this.dialogRef.close({ "option": "cancel" });
    });
  }

  ngOnInit(): void {
  }

  cancel() {
    this.dialogRef.close({ "option": "cancel" });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  addField() {
    if (this.fieldName != "" && this.fieldName != null && this.fieldName != ' ') {
      this.dialogRef.close({ "option": "change", "fieldName": this.fieldName });
    } else {
      this.openSnackBar(this.translate.instant("EDIT-FIELD-DIALOG.INFO-NEEDED"), this.translate.instant("SNACKBAR.DISMISS"));
    }
  }

}
